<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">基金投资人风险承受能力评价方法</span>
      <Reback class="row-one-fr" @click.native="returnOne"></Reback>
    </el-row>
    <div class="content">
      <div class="tit margin-t20">一、投资者进行风险测评的目的</div>
      <div>根据中国证监会发布的《证券期货投资者适当性管理办法》，向投资者销售证券期货产品或者提供证券期货服务的机构（以下简称经营机构）应当遵守法律、行政法规、《证券期货投资者适当性管理办法》及其他有关规定，在销售产品或者提供服务的过程中，
        勤勉尽责，审慎履职，全面了解投资者情况，深入调查分析产品或者服务信息，科学有效评估，充分揭示风险，基于投资者的不同风险承受能力以及产品或者服务的不同风险等级等因素，提出明确的适当性匹配意见，将适当的产品或者服务销售或者提供给适合的投资者，
        并对违法违规行为承担法律责任。为了贯彻落实该办法，展恒基金平台完善并更新了投资者风险测评流程。</div>
      <div class="tit">二、投资者分类</div>
      <div>展恒基金平台根据投资者不同风险偏好，将投资者分为以下五种类型：保守型、稳健型、平衡型、成长型、进取型。</div>
      <div>每类风格的投资者特征如下：</div>
      <div>1、保守型</div>
      <div>在基金投资过程中，保护本金不受损失和保持资产的流动性是您的首要目标。您对投资的态度是希望投资收益稳定，不愿或不能承担高风险以换取高收益，
        通常不太在意资金是否有较大增值，追求稳定。 有的投资者可能并不认为自己属于保守型一类，但因为年龄(65岁以上)或家庭的缘故，抗风险能力实际并不强，此时，获取稳定回报应当成为投资的首要考虑。</div>
      <div>风险承受能力：低</div>
      <div>获利期待：很稳定的投资收益</div>
      <div>2、稳健型</div>
      <div>稳定是您首要考虑的因素之一。在基金投资中，您希望在保证本金安全的基础上能有一些增值收入。追求较低的风险，对投资回报的要求不是太高。</div>
      <div>风险承受能力：中低</div>
      <div>获利期待：稳定的投资收益</div>
      <div>3、平衡型</div>
      <div>在基金投资的过程中，风险较小的情况下获得一定的收益是您主要的投资目的。您通常能接受使本金面临一定的风险，但在做投资决定时，会仔细地对将要面临的风险进行认真的分析。 总体来看，您愿意承受市场的平均风险。</div>
      <div>风险承受能力：中</div>
      <div>获利期待：中等回报率</div>
      <div>4、成长型</div>
      <div>在基金投资中，您渴望有较高的投资收益，但又不愿承受较大的风险；可以承受一定的投资波动，但是希望自己的投资风险小于市场的整体风险。您有较高的收益目标，且对风险有清醒的认识。</div>
      <div>风险承受能力：中高</div>
      <div>获利期待：中高回报率</div>
      <div>5、进取型</div>
      <div> 在基金投资中，您通常专注于投资的长期增值，并愿意为此承受较大的风险。短期的投资波动并不会对您造成大的影响，追求超高的回报才是您关注的目标。</div>
      <div>风险承受能力：高</div>
      <div>获利期待：高回报率</div>
      <div class="tit">三、基金产品风险等级划分</div>
      <div>展恒基金平台综合考虑各基金产品下行风险、最大回撤、收益率标准差、夏普比率、仓位（将股票、债券、其他占基金资产总值的比重分别赋予权重，计算最终仓位）五个指标，将平台基金产品风险等级划分为低、中低、中、中高、高五个等级。</div>
      <div class="tit">四、投资者适当性管理</div>
      <div>1、风险偏好为“保守型”投资者可投资风险等级为“低”的基金产品，不适宜购买其他风险等级基金产品；</div>
      <div>2、风险偏好为“稳健型”的投资者适合投资风险等级不高于“中低”的基金产品，投资高于“中低”风险等级的基金产品本平台会提示投资者，待投资者再次确认后方可完成购买；</div>
      <div>3、风险偏好为“平衡型”的投资者适合投资风险等级不高于“中”的基金产品，投资高于“中”风险等级的基金产品平台会提示投资者，待投资者再次确认后方可完成购买；</div>
      <div>4、风险偏好为“成长型”的投资者适合投资风险等级不高于“中高”的基金产品，投资高于“中高”风险等级的基金产品平台会提示投资者，待投资者再次确认后方可完成购买；</div>
      <div>5、风险偏好为“进取型”的投资者可投资各风险等级基金产品。</div>
      <el-button type="normal" class="margin-t70" style="margin-left:50%;transform: translateX(-50%);" @click="returnOne">确认</el-button>
    </div>
  </div>

</template>


<script>
export default {
  methods: {
    returnOne () {
      const path = this.$route.params.pathName
      if (path == "reevaluation") {
        this.$router.push({ name: 'accountManagement', params: { active: '3', risk: true } })
      } else if (path == "riskAssessment") {
        this.$router.push({ name: 'accountManagement', params: { active: '3', risk: false } })
      } else if (path == "riskResult") {
        this.$router.push({ name: 'riskResult', params: { message: this.$route.params.message } })
      } else {
        this.$router.push({ name: 'accountManagement', params: { active: '3' } })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 1000px;
  margin: 50px auto;
  box-sizing: border-box;
  div {
    text-indent: 28px;
    line-height: 30px;
  }
  .tit {
    text-indent: 0px;
    font-weight: bold;
  }
}
</style>